// extracted by mini-css-extract-plugin
module.exports = {"pagination":"List_pagination_3Vkeu","paginationText":"List_paginationText_2glUl","paginationButton":"List_paginationButton_oTICl"};